// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2cTV_","header":"ClearentDisclaimer_header__euvTo","inner":"ClearentDisclaimer_inner__1KnHn"};